module.exports = __webpack_public_path__ + "img/filter_blue.f5d2229d.svg";